import { Link } from 'react-router-dom'
import { Logo } from '../components/Logo'
import { SiteFooter } from '../components/SiteFooter'
import { ROUTE_META } from '../lib/site'
import { useDocumentTitle } from '../lib/useDocumentTitle'
import s from './Legal.module.css'

type LegalProps = {
  /** Front matter from the content file: title, lastUpdated, lead. */
  data: Record<string, string | undefined>
  /** Body, already compiled to HTML by scripts/vite-plugin-markdown.mjs. */
  html: string
  path: '/privacy' | '/terms'
}

/**
 * One layout, two routes. All copy — title, date, lead, and body — comes from
 * the Markdown file, so the client's legal text drops in without touching this
 * component.
 *
 * The HTML is compiled from a file in this repo at build time, so it is first-
 * party content, not user input.
 */
export function Legal({ data, html, path }: LegalProps) {
  const meta = ROUTE_META[path]
  useDocumentTitle(meta.title, meta.description)

  return (
    <div className={s.page}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <header className={s.nav}>
        <Logo asLink />
        <Link className={s.back} to="/">
          ← Back to home
        </Link>
      </header>

      <main id="main" className={s.main}>
        <div className={s.column}>
          {data.lastUpdated && <p className={s.eyebrow}>Last updated {data.lastUpdated}</p>}
          <h1 className={s.title}>{data.title ?? meta.title}</h1>
          {data.lead && <p className={s.lead}>{data.lead}</p>}

          <div className={s.prose} dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
